<div class="noty-container " [ngClass]="containerClass">

  <div class="text-container {{snackData ? 'snack-noty' : 'normal-noty'}}" >
    <div *ngIf="icon" class="noty-icon-container">
      <img [src]="_icon" >
    </div>
    <div class="noty-body">
      {{bodyText}}
    </div>
    <div *ngIf="showCta" class="cta" [ngClass]="size" (click)="onClick()">
      {{ctaText}}
    </div>
  </div>

  <mat-icon *ngIf="showCloseBtn" (click)="close()">clear</mat-icon>

</div>
